// extracted by mini-css-extract-plugin
export default {"task-active":"Z4BVFgkzNGHHP3Tci5NE","slide-up-down":"eSSwaEKB3brjpqzLtiKp","author":"Ml6CxsnXKtJvbEuqt5El","total":"bq7rpfY913Zp8ApXJvF5"};